'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { dispatchRouteChangeEvent } from '@/utils/routeEvents';
import { useUserStore } from '@/core/stores/user';
import useNextRouter from '@/hooks/useNextRouter';

const HotelRedirectButton = ({ to, children, actionMessage, ...props }: any) => {
    const router = useNextRouter();
    const { addActions } = useUserStore()

    const handleClick = () => {
        actionMessage && addActions({ type: 'click', message: actionMessage })
        dispatchRouteChangeEvent("start")
        router.push(to);
    };

    return (
        <button onClick={handleClick} {...props}>
            {children}
        </button>
    );
};

export default HotelRedirectButton;
